const SCREENING_RESULTS_ASSESSMENT_TYPES = {
  CLEARED: {
    value: "cleared",
    readableName: "Cleared",
  },
  UNDER_INVESTIGATION: {
    value: "under_investigation",
    readableName: "Under Investigation",
  },
  PEP: {
    value: "pep",
    readableName: "PEP",
  },
  TRUE_WATCHLIST_HIT: {
    value: "true_watchlist_hit",
    readableName: "True Watchlist hit",
  },
};

// Convert the object to an array of entries
export const screeningResultsAssessmentTypesArray = Object.values(
  SCREENING_RESULTS_ASSESSMENT_TYPES,
);
